/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a5074978"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "游戏信息", -1));
const _hoisted_2 = {
  class: "items items-grid"
};
const _hoisted_3 = {
  class: "item"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "游戏信息:", -1));
const _hoisted_5 = {
  class: "value"
};
const _hoisted_6 = {
  class: "item"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "渠道:", -1));
const _hoisted_8 = {
  class: "value"
};
const _hoisted_9 = {
  class: "item"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "区服名称:", -1));
const _hoisted_11 = {
  class: "value"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title marginT20"
}, "玩家信息", -1));
const _hoisted_13 = {
  class: "items"
};
const _hoisted_14 = {
  class: "item"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "游戏角色ID:", -1));
const _hoisted_16 = {
  class: "value"
};
const _hoisted_17 = {
  class: "item"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "设备号:", -1));
const _hoisted_19 = {
  class: "value"
};
const _hoisted_20 = {
  class: "items-grid"
};
const _hoisted_21 = {
  class: "item"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "UltraSDKID:", -1));
const _hoisted_23 = {
  class: "value"
};
const _hoisted_24 = {
  class: "item"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "角色账号ID:", -1));
const _hoisted_26 = {
  class: "value"
};
const _hoisted_27 = {
  class: "item"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "角色名称: ", -1));
const _hoisted_29 = {
  class: "value"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title marginT20"
}, "订单信息", -1));
const _hoisted_31 = {
  class: "items"
};
const _hoisted_32 = {
  class: "item"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "下单时间:", -1));
const _hoisted_34 = {
  class: "value"
};
const _hoisted_35 = {
  class: "item"
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "Ultra订单号:", -1));
const _hoisted_37 = {
  class: "value"
};
const _hoisted_38 = {
  class: "item"
};
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "第三方订单号:", -1));
const _hoisted_40 = {
  class: "value"
};
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title marginT20"
}, "商品信息", -1));
const _hoisted_42 = {
  class: "items items-grid"
};
const _hoisted_43 = {
  class: "item"
};
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "商品名称:", -1));
const _hoisted_45 = {
  class: "value"
};
const _hoisted_46 = {
  class: "item"
};
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "商品ID:", -1));
const _hoisted_48 = {
  class: "value"
};
const _hoisted_49 = {
  class: "item"
};
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "商品价格:", -1));
const _hoisted_51 = {
  class: "value"
};
const _hoisted_52 = {
  class: "item"
};
const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "币种:", -1));
const _hoisted_54 = {
  class: "value"
};
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title marginT20"
}, "支付信息", -1));
const _hoisted_56 = {
  class: "items items-grid"
};
const _hoisted_57 = {
  class: "item"
};
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "支付方式:", -1));
const _hoisted_59 = {
  class: "value"
};
const _hoisted_60 = {
  class: "item"
};
const _hoisted_61 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "提交金额:", -1));
const _hoisted_62 = {
  class: "value"
};
const _hoisted_63 = {
  class: "item"
};
const _hoisted_64 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "成交金额:", -1));
const _hoisted_65 = {
  class: "value"
};
const _hoisted_66 = {
  class: "item"
};
const _hoisted_67 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "商品价格:", -1));
const _hoisted_68 = {
  class: "value"
};
const _hoisted_69 = {
  class: "item"
};
const _hoisted_70 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "支付状态:", -1));
const _hoisted_71 = {
  class: "item"
};
const _hoisted_72 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "同步状态:", -1));
export default /*#__PURE__*/_defineComponent({
  __name: 'orderDetailDialog',
  emits: ['repairOrder', 'getReceiptTable'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const dialogVisible = ref(false);
    const currentOrder = ref({});
    const emits = __emit;
    const repairOrder = (type, data) => {
      emits('repairOrder', type, data);
    };
    // const getReceiptTable = (data: any) => {
    // 	emits('getReceiptTable', data);
    // };
    const handleClose = () => {
      dialogVisible.value = false;
    };
    const show = payload => {
      dialogVisible.value = true;
      currentOrder.value = payload.data;
    };
    __expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_el_dialog = __unplugin_components_1;
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: `订单明细(${_unref(currentOrder).id})`,
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        width: "700px",
        "close-on-click-modal": false,
        "before-close": handleClose
      }, {
        footer: _withCtx(() => [_unref(currentOrder).status !== 0 && [1, 2, 11, 12, 13, 14].includes(_unref(currentOrder).payType) ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          onClick: _cache[0] || (_cache[0] = $event => repairOrder('add', _unref(currentOrder))),
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("补单")]),
          _: 1
        })) : _createCommentVNode("", true), _unref(currentOrder).status === 0 && _unref(currentOrder).noticeStatus !== 0 && _unref(currentOrder).noticeStatus !== 2 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          onClick: _cache[1] || (_cache[1] = $event => repairOrder('sync', _unref(currentOrder))),
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("同步")]),
          _: 1
        })) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(currentOrder).gameName), 1)]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(currentOrder).cname || '暂无'), 1)]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(currentOrder).serverName || '暂无'), 1)])]), _hoisted_12, _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(currentOrder).roleId), 1)]), _createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(currentOrder).deviceId), 1)]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(currentOrder).uid), 1)]), _createElementVNode("div", _hoisted_24, [_hoisted_25, _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(currentOrder).suid), 1)]), _createElementVNode("div", _hoisted_27, [_hoisted_28, _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(currentOrder).roleName || '暂无'), 1)])])]), _hoisted_30, _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_hoisted_33, _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(currentOrder).createTime), 1)]), _createElementVNode("div", _hoisted_35, [_hoisted_36, _createElementVNode("div", _hoisted_37, _toDisplayString(_unref(currentOrder).hgOrderNo), 1)]), _createElementVNode("div", _hoisted_38, [_hoisted_39, _createElementVNode("div", _hoisted_40, _toDisplayString(_unref(currentOrder).thirdOrderNo), 1)])]), _hoisted_41, _createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_hoisted_44, _createElementVNode("div", _hoisted_45, _toDisplayString(_unref(currentOrder).productName), 1)]), _createElementVNode("div", _hoisted_46, [_hoisted_47, _createElementVNode("div", _hoisted_48, _toDisplayString(_unref(currentOrder).productId), 1)]), _createElementVNode("div", _hoisted_49, [_hoisted_50, _createElementVNode("div", _hoisted_51, _toDisplayString(_unref(currentOrder).submitAmount), 1)]), _createElementVNode("div", _hoisted_52, [_hoisted_53, _createElementVNode("div", _hoisted_54, _toDisplayString(_unref(currentOrder).currency), 1)])]), _hoisted_55, _createElementVNode("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, [_hoisted_58, _createElementVNode("div", _hoisted_59, _toDisplayString(_unref(currentOrder).payTypeName), 1)]), _createElementVNode("div", _hoisted_60, [_hoisted_61, _createElementVNode("div", _hoisted_62, _toDisplayString(_unref(currentOrder).submitAmount), 1)]), _createElementVNode("div", _hoisted_63, [_hoisted_64, _createElementVNode("div", _hoisted_65, _toDisplayString(_unref(currentOrder).dealAmount), 1)]), _createElementVNode("div", _hoisted_66, [_hoisted_67, _createElementVNode("div", _hoisted_68, _toDisplayString(_unref(currentOrder).submitAmount), 1)]), _createElementVNode("div", _hoisted_69, [_hoisted_70, _createElementVNode("div", {
          class: "value",
          style: _normalizeStyle({
            color: _unref(currentOrder).status === 0 ? '#52c41a' : '#f5222d'
          })
        }, _toDisplayString(_unref(currentOrder).statusName), 5)]), _createElementVNode("div", _hoisted_71, [_hoisted_72, _createElementVNode("div", {
          class: "value",
          style: _normalizeStyle({
            color: _unref(currentOrder).noticeStatus === 0 ? '#52c41a' : '#f5222d'
          })
        }, _toDisplayString(_unref(currentOrder).noticeStatusName), 5)])])]),
        _: 1
      }, 8, ["title", "modelValue"]);
    };
  }
});